import { ChainId } from '../types';
import { NATIVE_TOKEN_ADDRESS } from './constants';
export const ADDRESS_BY_CHAIN_L1 = {
    [ChainId.ETHEREUM]: {
        ETH: NATIVE_TOKEN_ADDRESS,
        WCRO: '0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b',
        ZkCRO: '0x28Ff2E4dD1B58efEB0fC138602A28D5aE81e44e2',
        USDC: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
        DAI: '0x6b175474e89094c44da98b954eedeac495271d0f',
        WBTC: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
        USDT: '0xdac17f958d2ee523a2206206994597c13d831ec7',
        CorgiAI: '0x6b431B8a964BFcf28191b07c91189fF4403957D0',
        FUL: '0x4eb8A4015A67975A23adc80aA50d2d996986F43D',
        // to be deployed later this year
        VNO: '',
        PrelaunchDeposit: '0xe8Dd4838C47EbF87D8FDb63E7f6Dd02C7432D2Ac',
        BridgeMiddleware: '0x3766Eb5F07DBc60d39a2059A9A29fD9b7D3C356D',
        Hyperchain: '0x7b2DA4e77BAE0e0d23c53C3BE6650497d0576CFc',
        YbETH: '0x76bf2D1e6dFda645c0c17440B17Eccc181dfC351',
        YbETHNft: '0x8F6B0512e63A644631694178B83419feCd90762D',
        YbETHBridge: '0xDED4Dd6E03A7CaA6278Ee453BE2C26363f50643D',
        YbUSD: '0xFA59075DfCE274E028b58BdDFcC3D709960F594a',
        YbUSDBridge: '0x17dacAD8AA962963830136422E2EAa8d27D014f8',
        ZkCroMintAndBridge: '0xE69a535730858fd8Dc386B448972A9f801aB4e12',
        Curve3Pool: '0xbEbc44782C7dB0a1A60Cb6fe97d0b483032FF1C7',
    },
    [ChainId.SEPOLIA]: {
        ETH: NATIVE_TOKEN_ADDRESS,
        WCRO: '0x4b7dfe9381149fa0e6738930fb24d015929c3926',
        ZkCRO: '0x49ce7551514f3c2bf44b50442765bb112d0e8204',
        USDC: '0xaA7963706A2cf29293f53f940655F480c7DFE839',
        DAI: '0xeF379A9B52A64DC0bc7bc0BF2EF23AFe52A8d0E8',
        WBTC: '',
        CorgiAI: '',
        FUL: '0x54927a7eF5AA6Fb31e59E52abaB675FA497Ac2a6',
        VNO: '',
        USDT: '0x8bE29A4Afd9793eCeD862849c3035fb97D934918',
        PrelaunchDeposit: '0xbfA65BD2555F80FE6A8a2a22de0530bD38Dfda95',
        BridgeMiddleware: '0x4F1CeDf1BE03F2100206aF843851c9B14210118a',
        Hyperchain: '0xeBf961DC3904725ec916678D875B9625d5F7C29f',
        YbETH: '0xF3DFc52db4604cbD6EdA747A70c82d7be122B545',
        YbETHNft: '0x2D98192b9106cBE946cC8DADf1A0E6EbC1100B84',
        YbETHBridge: '0x8507b280df746cb20075584CB920CbDE170d4AEB',
        YbUSD: '0xD2b6865fD9811d00121f6678a78dbC1CD95b1ec8',
        YbUSDBridge: '0xd520b497E75dB63288C89d7f8D8A34fD0D693fc0',
        ZkCroMintAndBridge: '0xCfa4A4e0ab77579CAdae9fb205fF6D89847b802B',
        Curve3Pool: '0xdE4dA18f7716876f79b9093Faa5047898476c546',
    },
};
